<template>
  <div class="">
    <oaExamineAudit v-if="isDetail" :viewDetailFun="detailOpenType" :openType="openType" :diaSize="drawerWidth" :iId="iId" ref="AuditOpenChild" :dialogInfo="dialogInfo" @close="handleClose"></oaExamineAudit>
    <template v-else>
      <!-- 因为数据导入的下拉选项和eldrawer有冲突 暂时先用自己的drawer -->
      <template v-if="isBulkImport && openType === 'rightdia'">
        <drawer v-model="isdiaVisible" title="数据导入" :width="drawerWidth" @close="handleClose">
          <component v-if="isdiaVisible" :is="isComp" :customDeskInfo="customDeskInfo" :id="customDeskInfo && customDeskInfo.reportId" @submitCallBack="submitCallBack" @loadCallBack="loadCallBack" />
        </drawer>
      </template>
      <div v-else v-show="!iAgreePargam.Visible">
        <component
          :is="componentsType"
          v-model="isdiaVisible"
          :class="`new-status-dialog new-status-dialog-autoh ${isAppAi ? 'opacity-app' : ''}${isSubmit ? 'opacity-sub' : ''}${isBulkImport || (visiable && datatype !== 5)? '' : ''}${fullscreen ? 'fullscreen-dialog' : ''}${isChatPath ? 'chat-path-dialog' : ''}`"
          :show-close="false"
          :fullscreen="fullscreen"
          :close-on-press-escape="false"
          @close="handleClose"
          :width="widthComp"
          append-to-body
          :size="drawerWidth" 
          :with-header="false"
          :style="[{ '--el-dialog-padding-primary': 0, overflow: 'hidden', borderRadius: '20px' }, openType === 'rightdia'? 'marginTop: 0px !important;borderRadius: 0' : '' ]"
        >
          <div v-if="!isChatPath" :class="['dialog-top', isfaceAr !== 0 ? 'dialog-top-black' : '']">
            <template v-if="datatype !== 5">
              <div class="app-title">
                {{ dialogInfo.dialogName }}
              </div>
              <div class="face-ar" v-if="isfaceAr !== 0">
                <span
                  class="active-hover"
                  @click="faceArChange"
                >
                  <i
                    v-show="isfaceAr === 1"
                    class="iconfont icon-AR1"
                    style="font-size: 20px"
                  />
                  <i
                    v-show="isfaceAr === 2"
                    class="iconfont icon-AR"
                    style="font-size: 20px"
                  />
                </span>
              </div>
              <div v-if="isAi" class="app-view ai-but" @click="upIsAi(isAi === 1 ? 2 : 1)"
              :style="{color: isAi === 1 ? '#4e86ff' : ''}">
                <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/ai.png" style="width:25px;height:25px;vertical-align: inherit;margin-right:4px;" />
                  AI小易
              </div>
              <div class="app-view" v-if="flowshow != 2" @click="onFlowshow">
                <i class="el-icon-view"></i>
                {{ getFlowShowText() }}
              </div>
            </template>
            <div v-else class="app-title"></div>
            <div class="app-boost">
              <i
                v-if="openType !== 'rightdia'"
                class="iconfont"
                :class="fullscreen ? 'icon-suoxiao1' : 'icon-fangda2'"
                @click="fullscreen = !fullscreen"
              ></i>
            </div>
            <div class="app-close" @click="handleClose">
              <i class="iconfont icon-shanchu3"></i>
            </div>
          </div>
          <div :class="pdheight == 'auto' ? 'dialog-height-auto' : 'dialog-main'"
            :style="{ 
              height: openType === 'rightdia' ? 'calc(100% - 44px)' : pdheight== 'auto' ? 'auto' : dialogInfo.dialogHeight,
              transform: isBulkImport || (visiable && datatype !== 5) ? '' : 'translate(0, 0)',
              paddingTop: isChatPath ? '37px' : ''
            }">
            <oaExamineInput
              v-if="visiable && datatype !== 5"
              :isDoorAdd="true"
              :approvalId="appId"
              :openfunction="openfunction"
              :coverVal="coverVal"
              v-model:isAi="isAi"
              :themeColor="themeColor"
              @isSubmit="upIsSubmit"
              @upIsAi="upIsAi"
              @upIsPcwidth="upIsPcwidth"
              @upIsPcHeight="upIsPcHeight"
              @getfaceAr="getfaceAr"
              @loadSuccess="loadSuccess"
              @change-iagreepargam="changeIagreepargam"
              :modify="iId === 13 || iId === 14 ? modify : ''"
              :person="iId === 14 ? 0 : 1"
              :pageId="iId === 14 ? 7 : 1"
              :pageType="dialogInfo.pageType"
              @refFlowshow="refFlowshow"
              @inputClose="inputClose"
              @doorUp="doorUp"
              @upBaseset="upBaseset"
              type="1"
              ref="AuditOpenInput"
            ></oaExamineInput>
            <template v-else-if="isdiaVisible">
              <template v-if="isComp">
                <component :isComp="true" :is="isComp" :customDeskInfo="customDeskInfo" :id="customDeskInfo && customDeskInfo.reportId" :isSystemPersonal="isSystemPersonal" :isAppenTitle="false" @submitCallBack="submitCallBack" @close="handleClose" @loadCallBack="loadCallBack" />
              </template>
              <template v-else>
                <iframe
                  allow="clipboard-read; clipboard-write"
                  sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads allow-modals"
                  :src="datatype === 5 ? coverVal : dialogInfo.dialogUrl"
                  frameborder="0"
                  width="100%"
                  height="100%"
                ></iframe>
              </template>
            </template>
          </div>
        </component>
      </div>
    </template>
  </div>
</template>

<script>
import { getuserfielddatalist } from '@/port/clientSide/applicationRouting'
import { getapifielddatalist, getopenreportformlist } from '@/port/clientSide/workbench'
import qs from 'qs'
import { timeFormatDate } from "../../../api/global";
import organization from '@/components/admins/organization/organization'
import organizationRole from '@/components/admins/organization/organizationRole'
import organizationUser from '@/components/admins/organization/organizationUser'
import operationLog from '@/components/admins/organization/operationLog'
import knowledgeBase from '@/views/knowledgeBase/index'
import customInstrument from '../customInstrument.vue'
import instrument from '@/components/clientSide/instrument/instrument'
import application from '@/components/clientSide/applicationRouting'
import reportView from '@/components/reportView/index'
import TMbulkImport from '@/components/clientSide/workbench/newTMbulkImport.vue'
import { ElDialog, ElDrawer } from 'element-plus';
import chat from '@/components/clientSide/chat'
import chatCommon from '@/components/common/chat'
import { defineAsyncComponent } from 'vue';
export default {
  name: 'appDialog',
  components: {
    oaExamineInput: defineAsyncComponent(() => import('@/components/clientSide/oaExamineInput.vue')),
    oaExamineAudit: defineAsyncComponent(() => import('@/components/clientSide/oaExamineAudit.vue')),
    drawer: defineAsyncComponent(() => import('@/components/common/drawer/index.vue'))
  },
  data () {
    return {
      // 是不是新增
      visiable: false,
      isdiaVisible:false,
      // 是否显示流程
      flowshow: 2,
      // 是否全屏
      fullscreen: false,
      modify: null,
      isAi: 0,
      isfaceAr: 0, //0 未配置人脸识别 1 拍摄模式 2 AR模式
      pdwidth: 75,
      pdheight: 'regular',
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      showModal: false, //是否显示遮罩层
      iAgreePargam: {},
      isSystemPersonal: false,
      customDeskInfo: {},
      isSubmit: false,
      isAppAi: false, //是否从表单ai模板打开
      detailOpenType: 'app-detail',
      baseSet:{
        grouping: 0, // 0：当前用户 1：当前应用
        flowshow: {
          type: 'merge',
          width: '345px'
        }
      }, // 流程设置新增的JSON
      isBulkImport: false, // 是否应用导入数据
      agentConfig: {
        style: {
          style: 1
        }
      }, //ai智能体配置
    };
  },
  props: {
    // 弹窗所有的信息
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          dialogName: '',
          isVisible: false,
          dialogWidth: '',
          dialogHeight: '',
          dialogUrl: '',
          diaSize: 'custom',
          customSize: 65,
          openType: 'dialog',
          childDialog: true,
          pageType: ''
        }
      }
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    appId: {
      type: [Number, String]
    },
    addInputShow: {
      type: Boolean,
      default: false
    },
    // 打开使用的值
    coverVal: {
      type: [Object, String],
      default: () => { }
    },
    iId: {
      type: [String, Number],
    },
    isDetail:{
      type:Boolean,
      default:false
    },
    datatype: [String, Number],
    openfunction: {
      type: Object,
      default: ()=>({})
    },
    updateDataInfo: {
      type: Object,
      default: ()=>({})
    }
  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }    
  },
  computed: {
    componentsType() {
      if (this.openType !== 'rightdia') {
        return ElDialog
      } else {
        return ElDrawer
      }
    },
    widthComp() {
      let width = this.dialogInfo.dialogWidth
      const obj = {
        11: true,
        13:true,
        14:true,
        15:true,
        16:true,
        19:true,
        20:true,
        23:true,
        24:true,
        25:true,
      }
      const diaSize = this.dialogInfo.diaSize
      if (obj[this.iId] && this.pdwidth) {
        width = this.pdwidth + '%'
      }
      if (diaSize !== 'custom' && this.openType !== 'rightdia') {
        width = diaSize
      }

      if (diaSize === 'custom' && this.openType === 'rightdia') {
        width = this.dialogInfo.customSize + '%'
      }
      if (typeof width === 'undefined') { 
        return ''
      }
      return width
    },
    isComp() {
      const obj = {
        '/organization': organization,
        '/organizationRole': organizationRole,
        '/organizationUser': organizationUser,
        '/operationLog': operationLog,
        '/knowledgeBase': knowledgeBase,
      }
      let path = this.dialogInfo.dialogUrl
      if (path && path.includes('userId') && path.includes('operationLog')) {
        path = '/operationLog'
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isSystemPersonal = true
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isSystemPersonal = false
      }
      let flag = obj[path]
      if (!flag) {
        // 由于 需要把场景和仪表盘和报表和表单变成组件模式 这边再去判断
        let queryStr = ''
        try {
          queryStr = decodeURIComponent(path).split('?')[1]
        } catch (error) {
          queryStr = path.split('?')[1]
        }
        // 针对欧总发的同安一中数学函数的问题，存在转义字符&解析报错的问题
        if(queryStr){
          try {
            queryStr = queryStr.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
            queryStr = qs.parse(queryStr, {
              decoder: (str)=> decodeURIComponent(str.replace(/\+/g, '%2B'))
            })
          } catch (error) {
            queryStr = queryStr.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
            queryStr = qs.parse(queryStr)
          }
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.customDeskInfo = queryStr
        // 选择的知识库
        if(this.dialogInfo.valueKnowledge && this.dialogInfo.valueKnowledge.length > 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.customDeskInfo.valueKnowledge = this.dialogInfo.valueKnowledge
        }
        // ai智能体配置
        if(this.dialogInfo.agentConfig){
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.agentConfig = this.dialogInfo.agentConfig
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.customDeskInfo.agentConfig = this.dialogInfo.agentConfig
        }
        else{
          let path = this.dialogInfo.dialogUrl || ''
          if (path && path.includes('/aichatNew')) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.agentConfig = {
              style: {
                style: 0
              }
            }
          }
        }    
        // 预设参数&常用问题设置
        if(this.dialogInfo.paramQuesConfig){
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.customDeskInfo.paramQuesConfig = this.dialogInfo.paramQuesConfig
        }
        // 当前aiId
        if(this.dialogInfo.chatId) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.customDeskInfo.chatId = this.dialogInfo.chatId
        }
        if (path && path.includes('/customInstrument')) {
          flag = customInstrument
        } else if (path && path.includes('/clientSide/instrument/instrument')) {
          // 仪表盘
          flag = instrument
        } else if (path && path.includes('/clientSide/reportView')) {
          // 报表
          flag = reportView
        } else if (path && path.includes('/clientSide/workbench/TMbulkImport')) {
          if (this.dialogInfo.chooseField) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.customDeskInfo.chooseField = this.dialogInfo.chooseField
          }
          // 导入
          flag = TMbulkImport
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isBulkImport = true
        } else if (path && path.includes('/clientSide/application')) {
          // 应用
          flag = application
        } else if (path && path.includes('/chat')) {
          // ai小易
          flag = chat
          // 表单页 点击ai模板加上loading
          if (queryStr.channel && queryStr.channel === 'appAi') {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.isAppAi = true
            document.body.classList.add('hopup-body');
          }
        } else if (path && path.includes('/aichatNew')) {
          // ai小易-聊天页面
          flag = chatCommon
        }
      }
      if (flag) {
        return flag
      } else {
        return false
      }
    },
    drawerWidth() {
      const diaSize = this.dialogInfo.diaSize
      if (diaSize && diaSize !== 'custom') {
        return diaSize
      }
      if (diaSize === 'custom') {
        return this.dialogInfo.customSize + '%'
      }
      return ''
    },
    openType() {
      return this.dialogInfo.openType
    },
    isChatPath() {
      const path = this.dialogInfo.dialogUrl || ''
      return this.agentConfig && this.agentConfig.style && this.agentConfig.style.style === 1 && (path.includes('/chat') || path.includes('/aichatNew'))
    }
  },
  methods: {
    upBaseset (val) {
      this.baseSet = val
    },
    getFlowShowText () {
      let str = '流程'
      if (this.baseset) {
        const baseset = typeof this.baseset === 'string' ? JSON.parse(this.baseset) : this.baseset
        if (baseset.flowshow && baseset.flowshow.type) {
          if (baseset.flowshow.viewText) {
            str = baseset.flowshow.viewText
          } else {
            str = baseset.flowshow.type === 'dialogue' ? '交流' : '流程'
          }
        }
      }
      return str
    },
    upIsSubmit (e) {
      this.isSubmit = e
    },
    changeIagreepargam(val) {
      if(val.Visible === undefined){
        val.Visible = false
      }
      this.iAgreePargam = val
    },
    upIsAi (val) {
      this.isAi = val
    },
    upIsPcwidth(val) {
      this.pdwidth = val
    },
    upIsPcHeight(val){
      this.pdheight = val
    },
    // 弹窗完成加载
    loadSuccess(){
      console.log('弹窗完成加载',this.showModal)
      setTimeout(() => {
        document.body.classList.remove('rout-opendialog');
        this.addMask()
        this.showModal = false
      }, 300);
    },
    // 获取人脸识别是否打开
    getfaceAr(val){
      this.isfaceAr = val
      if(this.isfaceAr !== 0){
        this.fullscreen = true
      }
      else{
        this.fullscreen = false
      }
      console.log("this.isfaceAr==",this.isfaceAr);
    },
    // 切换人脸识别模式
    faceArChange(){
      this.isfaceAr = this.isfaceAr === 1 ? 2 : 1
      this.$refs.AuditOpenInput.faceArChange(this.isfaceAr)
    },
    addMask() {
      return false;
      // const existingMask = document.getElementById('j-mask-dialogC');
      // if (existingMask) {
      //   // 如果遮罩层已经存在，跳过创建步骤
      //   return;
      // }
      // // 创建遮罩层元素
      // const mask = document.createElement('div');
      // mask.id = 'j-mask-dialogC';
      // mask.style.cssText = `
      //   position: fixed;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 100%;
      //   background: rgba(0, 0, 0, 0.5);
      //   z-index: 99;
      //   transition: opacity 0.3s;
      //   opacity: 0;
      // `;
      // // 使用 setTimeout 模拟遮罩层渐变效果
      // setTimeout(() => {
      //   mask.style.opacity = 1;
      // }, 10);
      
      // // 将遮罩层添加到 body
      // document.body.appendChild(mask);
      
      // // 点击遮罩层关闭弹窗
      // mask.onclick = () => {
      //   this.showModal = false;
      // };
    },
    removeMask() {
      // 获取遮罩层元素
      const mask = document.getElementById('j-mask-dialogC');
      console.log("mask==",mask);
      if (mask) {
        document.body.removeChild(mask);
      }
    },
    // 返回给仪表盘刷新的
    doorUp () {
      this.$emit('doorUp')
    },
    refFlowshow (res) { // 子集
      this.flowshow = res
    },
    onFlowshow () {
      this.flowshow = this.flowshow ? 0 : 1
      this.$refs.AuditOpenInput.flowshow = this.flowshow
    },
    // 关闭input
    inputClose () {
      this.$refs.AuditOpenInput.closeSetTime()
      this.visiable = false;
      if (this.iId === 13 || this.iId === 14) {
        // eslint-disable-next-line vue/no-mutating-props
        this.dialogInfo.isVisible = false
        this.isdiaVisible = false
      }
      if (!this.isDetail && this.datatype !== 5 && this.dialogInfo.isVisible) {
        // eslint-disable-next-line vue/no-mutating-props
        this.dialogInfo.isVisible = false
        this.isdiaVisible = false
      }
    },
    handleClose () {
      this.visiable = false
      // 查询是否存在需要刷新的
      if (this.iId === 13 || this.iId === 14 || this.iId === 20 || this.isDetail || typeof this.iId === 'string') {
        this.doorUp()
      }
      // 关闭弹窗是清除临时token
      const temporaryToken = sessionStorage.getItem('temporaryToken')
      if (temporaryToken) sessionStorage.removeItem('temporaryToken')
      localStorage.removeItem('currentTranscription')
      localStorage.removeItem('visitorUser')
      if(this.isDetail) this.iAgreePargam.Visible = true
      this.$emit('update:addInputShow', false)
      this.$emit('update:isDetail', false)
      // eslint-disable-next-line vue/no-mutating-props
      this.dialogInfo.dialogUrl = ''
      // eslint-disable-next-line vue/no-mutating-props
      this.dialogInfo.isVisible = false
      this.customDeskInfo = {}
      // 这个仪表盘表示的
      this.$emit('close')
    },
    // ai小易加载完成后，如果存在用户手动输入的步骤，则关闭loading
    loadCallBack(val){
      this.$emit('loadCallBack')
      this.isAppAi = false
      if (val && Object.keys(val).length > 0) {
        this.agentConfig = val
      } else {
        this.agentConfig = {
          style: {
            style: 0
          }
        }
      }
      document.body.classList.remove('hopup-body');
      console.log("loadCallBack==");
    },
    // ai小易编辑后回调到表单页面
    submitCallBack(val){
      this.$emit('submitCallBack', val)
      console.log("submitCallBack==",val);
      document.body.classList.remove('hopup-body');
    },
    // 关闭弹窗
    closePop(){
      this.isdiaVisible = false
    },
    async getDetailInfo (val, query) {
      // 首先获取 权限
      const params = {
        approvalId: this.appId,
        approving: {},
      }
      const _power = {
        approvalId: this.appId,
        curpage: 0,
        pagesize: 0
      }
      if (this.$route.query.spaceid || this.$route.query.space) {
        _power.spaceid = this.$route.query.spaceid || localStorage.getItem('spaceid')
      }
      else if (this.$route.query.upaceid || this.$route.query.upace) {
        _power.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }
      const { data, code, msg } = await getopenreportformlist(_power)
      if (code === 0) {
        let power = {}
        if (this.iId === 15 || this.iId === 13) {
          power = data.find(item=>item.userId)
        }else {
          power = data.find(item=>!item.userId)
        }
        const _list = {
          type: 0,
          curpage: 1,
          pagesize: 20,
          cateId: -1,
          key: '',
          querys: {},
          query: query || {},
          approvalId: this.appId,
          reportFormId: power.reportFormId
        }
        // 从空间进入，需要传空间id
        if(this.isSpace){
          let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
          _list.spaceid = spaceId;
        }
        else if(this.isUpace){
          let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
          _list.upaceid = upaceId;
        }
        const fn = this.iId === 15 || this.iId === 13 ? getuserfielddatalist : getapifielddatalist
        if (this.iId === 19 || this.iId === 20) {
          _list.datanum = 1
        }
        const { data: list, code: code1, msg: msg1 } = await fn(_list)
        if (code1 === 0) {
          const ids = [13, 14, 15, 16, 19, 20, 23, 24, 25]
          if (ids.indexOf(this.iId) !== -1) {
            if (list.length === 0) {
              this.$message.warning('暂无可查看数据！')
              return
            }
            list[0].powerInfo = power
            return list[0]
          }
          const list1 = list[0]
          if (list1) {
            params.approving.approvingId = list1.approvingId
            params.userapprovingId = list1.userApprovingId
          }
        } else {
          this.$message.error(msg1)
        }
      } else {
        this.$message.error(msg)
      }
      return params
    },
    getSearch() {
      if (!this.coverVal) return
      if (typeof this.coverVal === 'object') return this.coverVal
      const search = this.coverVal.split('?')
      if (search.length > 0) {
        let s = search.slice(1, search.length)
        s = s.join('?')
        s = qs.parse(s)
        if (s.search) {
          const se = JSON.parse(s.search)
          const obs = {}
          // const key = []
          const obj = {
            '归档状态_status': 'archive_radio',
            '申请人_relation-user': 'appuser_appuser'
          }
          const statusObj = {
            '待审批': 0,
            '已通过': 1,
            '未通过': 2,
            '已撤回': 3
          }
          for (const i in se) {
            const val = Array.isArray(se[i]) ? se[i] : [se[i]]
            // 数字值处理下
            if (i === 'status_status') {
              for (let s = 0; s < val.length; s++) {
                val[s] = statusObj[val[s]] || val[s]
              }
            } else if (i === 'date_timeof') {
              for (let s = 0; s < val.length; s++) {
                val[s] = timeFormatDate(new Date(val[s]).getTime())
              }
              if (val.length === 1) {
                val.push(val[0])
              }
            }
            if (obj[i]) {
              obs[obj[i]] = val
            } else {
              obs[i] = val
            }
          }
          return obs
        }
      }
    }
  },
  watch: {
    'dialogInfo.isVisible': {
      deep: true,
      immediate: true,
      handler(val) {
        if (val === false) {
          this.isdiaVisible = false
          this.visiable = false
          this.showModal = false
          this.isBulkImport = false
          // 关闭摄像头
          // this.$closeGestureController()
          // eslint-disable-next-line vue/no-mutating-props
          this.dialogInfo.isVisible = false
          // eslint-disable-next-line vue/no-mutating-props
          this.dialogInfo.childDialog = false
          
          // this.removeMask()
          return
        }
        if (this.iId === 13 || this.iId === 14 || this.iId === 20) {
          const query = this.getSearch()
          // this.dialogInfo.isVisible = false
          this.visiable = false          
          // 第一条数据查询
          if (this.updateDataInfo && Object.keys(this.updateDataInfo).length > 0) {
            this.modify = this.updateDataInfo
            this.visiable = true
            this.isdiaVisible = true
          } else {
            this.getDetailInfo(this.iId, query).then((res) => {
              if (res) {
                res.modifyId = res.approvingId
                this.modify = res
                this.visiable = true
                this.isdiaVisible = true
              } else {
                this.$emit('close')
              }
            })
          }
          return
        }
        if (this.iId === 11) {
          let textInfo = localStorage.getItem('currentTranscription');
          if (textInfo) {
            textInfo = JSON.parse(textInfo);
            textInfo.isAi = true
            localStorage.setItem('currentTranscription', JSON.stringify(textInfo))
          }
        }
        if (val) {
          this.visiable = this.addInputShow
          this.isdiaVisible = true
          this.showModal = true     
          document.body.classList.add('rout-opendialog');
        }
        this.pdheight = 'regular'
      }
    },
    isDetail:{
      async handler(val){
        if (val) {
          const detailList = [15, 16, 19, 23, 24, 25]
          if ([23, 24, 25].includes(Number(this.iId))) {
            this.detailOpenType = 'app-comment'
          } else {
            this.detailOpenType = 'app-detail'
          }
          if (detailList.includes(Number(this.iId))) {
            // 解析str
            const query = this.getSearch()
            // eslint-disable-next-line vue/no-mutating-props
            this.dialogInfo.isVisible = false
            this.getDetailInfo(this.iId, query).then((res) => {
              if (!res) {
                this.$emit('close') 
                return
              }
              if (!res.approvalId) {
                res.approvalId = this.appId
                res.approving = {
                  approvingId: res.approvingId
                }
              }
              if (res.userApprovingId) res.userapprovingId = res.userApprovingId
              if (res.powerInfo) {
                // 个人数据查看，必然会有编写和删除权限
                res.delete = res.powerInfo.delete
                res.update = res.powerInfo.update
              }
              this.$refs.AuditOpenChild.AuditOpenList(res)
            })
          }
        }
      },
      immediate: true
    },
    showModal (val) {
      console.log("showModal==",val,this.isdiaVisible);
      if (!val && this.isdiaVisible) {
        this.addMask();
      } else {
        this.removeMask();
      }
    },
    isdiaVisible: {
      immediate: true,
      handler (val) {
        if (!val) {
          if(!this.showModal && !Object.prototype.hasOwnProperty.call(this.dialogInfo, 'childDialog')){
            this.removeMask();
          }
        }
        else{
          this.addMask();
          document.body.classList.remove('rout-opendialog');
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.drawer-title {
  height: 36px;
  box-sizing: border-box;
  display: flex;
  padding: 0 22px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #EAECF0;
  .close {
    .icon-shanchu3 {
      cursor: pointer;
      &:hover {
        color: #4e86ff
      }
    }
  }
}

::v-deep .drawer-add-input {
  height: calc(100% - 32px) !important;
}

::v-deep .dialog-center {
  margin-top: 0 !important;
  transform: translateY(-50%);
  top: 50%;
}

.dialog-top {
  background-color: #f5f5f5;
  padding: 0 15px;
  height: 44px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .app-title {
    flex: 1;
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }
  .app-view {
    width: 110px;
    box-sizing: border-box;      
    border-right: 1px solid #d8d8d8;
    height: 100%;
    text-align: center;
    line-height: 44px;
    margin-right: 15px;
    cursor: pointer;
    &:hover {
      color: #4e86ff;
    }
  }
  .ai-but {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0;
  }
  .app-boost {
    width: 30px;
    cursor: pointer;
    text-align: center;
    &:hover {
      color: #4e86ff;
    }
  }
  .app-close {
    width: 30px;
    cursor: pointer;
    text-align: center;
    &:hover {
      color: #4e86ff;
    }
  }
}

::v-deep .fullscreen-dialog {
  margin-top: 0 !important;
}

::v-deep .opacity-app {
  opacity: 0 !important;
  .el-dialog__wrapper {
    opacity: 0 !important;
    transition: opacity 0.3s ease; // 添加过渡效果
  }
}
::v-deep .transparent-drawer {
  background: transparent !important;
  box-shadow: none !important;
}
// .rout-opendialog {
//   .el-dialog__wrapper {
//     ::v-deep .new-status-dialog {
//       opacity: 0 !important;
//     }
//   }
// }

// ::v-deep .el-dialog__body {
//   .application-rout {
//     .application-nav {
//       top: initial;
//     }
//   }
// }

// ::v-deep .opacity-sub {
//   background: transparent;
//   .dialog-top {
//     display: none;
//   }
//   .oaExamineInput {
//     background: transparent;
//     opacity: 0;
//     .oaExamineAllArea, .oaExamineInput {
//       opacity: 0;
//     }
//   }
// }
</style>
<style lang='scss'>
.new-status-dialog-autoh {
  overflow: hidden;
  margin-top: 5.4vh !important;
  border-radius: 14px;
  transition: 0.3s;
  box-shadow: none !important;
  &.chat-path-dialog {
    margin-top: 0.2vh !important;
  }
  .el-dialog__header {
    display: none;
  }
  .dialog-top-black {
    background: #000;
    border-bottom: 1px solid #000;
    color: #fff;
    .app-title {
      color: #fff;
    }
    .face-ar {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0;
      padding: 3px 16px 0;
      border-right: 1px solid #333;
      i {
        cursor: pointer;
      }
    }
    .app-view {
      border-right: 1px solid #333;
    }
  }
  .el-dialog__body {
    padding: 0;
    .el-tabs {
      height: 100%;
      .el-tabs__content {
        height: 100%;
        .el-tab-pane {
          height: 100%;
          .el-row {
            height: 100%;
          }
        }
      }
    }
    // pc弹窗高度-自适应
    .dialog-height-auto {
      .oaExamineInput {
        position: inherit;
        .oaExamineAllArea {
          .wisdomSubmit {
            .wisdomSubmitBox {
              position: inherit;
            }
          }
        }
      }
      .oaExamineInput {
        .wisdomSubmit {
          .inputBoxArea  {
            .el-scrollbar__view {
              max-height: 75vh !important;
            }
          }
        }
      }
    }    
    .success-loading1 {
      left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%) !important;
    }
  }
}
.dialog-main {
  height: calc(100% - 44px);
  overflow: auto;
  box-sizing: border-box;
}
</style>